import React from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import { logoutUser } from '@disco/state-management/actions/UserActions'

function Logout() {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  React.useEffect(() => {
    const sessionExpired = searchParams.get('sessionExpired') === '1'
    dispatch(logoutUser(sessionExpired))
  }, [dispatch, searchParams])

  return null
}

export default Logout
